/**
 * Layout atoms: roots, flex helpers, loaders, full-bleed shells, floating chrome.
 * @see atomicRules.ts
 */
import { Platform, StyleSheet, ViewStyle } from 'react-native';
import { appTheme } from '../appTheme';

export {
  androidFrostedFallbackBackground,
  androidFrostedHeaderShellRest,
  blurIntensityForPlatform,
  blurViewWrapperProps,
  FROSTED_BOTTOM_CHROME_RADIUS,
  glassAccentBorderStyle,
  shouldRenderNativeFrostedBlur,
  resolveAndroidFrostedSurfaceLayers,
  resolveBlurTint,
  type AndroidFrostedWeight,
  type BlurTint,
  androidStripElevationSeams,
  androidHideFrostedChromeHairline,
  androidReducedSafeAreaTopInset,
  MENU_FLOW_HEADER_DATE_BLOCK_HEIGHT,
  frostedChromeShadow,
} from '../blurParity';
export {
  androidAppHeaderContentHeight,
  androidAppHeaderContentTop,
  androidDashboardHeaderCollapsedHeight,
  androidDashboardHeaderExpandedHeight,
  androidDashboardHeaderScrollThreshold,
  androidFlatSurfaceStyle,
  androidGlassHeaderContentTop,
  androidHeaderTopInset,
  androidResolveShadow,
  androidPlatformShadow,
  androidScaleFont,
  androidScaleSize,
  androidScaleSpace,
  androidScaleTextStyle,
  androidUiScaleFactor,
  isAndroidUi,
} from '../androidUiParity';

export const loaderViewport: ViewStyle = {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: appTheme.colors.background,
};

export const rootFill: ViewStyle = {
  flex: 1,
  backgroundColor: appTheme.colors.background,
};

export const flexCenter: ViewStyle = {
  justifyContent: 'center',
  alignItems: 'center',
};

export const row: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: appTheme.spacing.sm,
};

export const fullBleedRoot: ViewStyle = {
  flex: 1,
  backgroundColor: appTheme.colors.background,
};

export const fullBleedList: ViewStyle = {
  ...StyleSheet.absoluteFillObject,
};

export const floatingTopBar: ViewStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 2,
};

export const floatingTopBarRow: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingHorizontal: appTheme.spacing.lg,
  minHeight: 52,
};

export const floatingBottomStack: ViewStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 2,
};
